// extracted by mini-css-extract-plugin
module.exports = {"centeredInput":"MFACode_centeredInput__1tEtr"};